import { render, staticRenderFns } from "./down.vue?vue&type=template&id=7b8cba3d&scoped=true&"
import script from "./down.vue?vue&type=script&lang=js&"
export * from "./down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8cba3d",
  null
  
)

export default component.exports